<template>
  <section v-if="open" class="ns-popup-section-wrapper" @click="closeHandler">
    <div class="ns-popup-container">
      <div class="ns-popup-content-container" :style="containerStyles">
        <div
          v-if="!hideCloseButton"
          class="ns-popup-close-button"
          @click="open = false"
        >
          <NsIcon icon-name="icon-close" />
        </div>
        <header class="ns-popup-header">
          <!-- @slot The header slot. Will be enclosed in a header tag. -->
          <slot name="header"></slot>
        </header>
        <p v-if="text" class="ns-popup-text">{{ text }}</p>
        <!-- @slot The default slot. Enclosed in a container div with both the header and footer tags (and their accompanying slots). -->
        <slot class="ns-popup-main"></slot>
        <footer class="ns-popup-footer">
          <!-- @slot The footer slot. Will be encolsed in a footer tag. -->
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </section>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsHeader',
  components: {
    NsIcon,
  },
  emits: [
    /**
     * An event that is emitted when the open property is changed with the new value.
     */
    'toggled',
  ],
  props: {
    /**
     * Hides the close button and changes the behavior to close the popup when clicking anywhere on the popup or the grayed out area behind.
     */
    hideCloseButton: {
      default: false,
      type: Boolean,
    },
    /**
     * Determines whether or not the popup is open or closed.
     * (Using v-if not v-show)
     */
    open: {
      default: false,
      type: Boolean,
    },
    /**
     * Changes the styles on the container (not the grayed out area behind)
     */
    containerStyles: {
      default: () => ({
        paddingTop: '30px',
        paddingRight: '20px',
        paddingBottom: '30px',
        paddingLeft: '20px',
      }),
      type: Object,
    },
    /**
     * Displays text in a paragraph tag if populated.
     */
    text: {
      default: '',
      type: String,
    },
  },
  watch: {
    open(newValue) {
      /**
       * An event that is emitted when the open property is changed.
       * @bind newValue The new value of the open property.
       */
      this.$emit('toggled', newValue);
    },
  },
  methods: {
    closeHandler() {
      if (this.hideCloseButton) {
        this.open = false;
      }
    },
  },
};
</script>

<style scoped>
section {
  align-items: center;
  background-color: rgb(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 50;
}

div.ns-popup-container {
  background-color: white;
  border-radius: 3px;
  box-shadow: 0px 9px 13px 3px rgba(29, 37, 64, 0.5);
  -webkit-box-shadow: 0px 9px 13px 3px rgba(29, 37, 64, 0.5);
  max-height: calc(var(--vh, 1vh) * 50);
  max-width: 90vw;
  overflow-y: auto;
  position: fixed;
  top: 40vh;
  z-index: 51;
  @media only screen and (min-width: 768px) {
    max-width: 768px;
  }
}

div.ns-popup-content-container {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 30px 20px;
  position: relative;
}

.ns-popup-close-button {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 52;
}
</style>
